import { localizationStringsFr } from './fr';
import { localizationStringsEn } from './en';
import { localizationStringsDe } from './de';
import { localizationStringsIt } from './it';

export const IdScanlocalizationStrings = {
  de: localizationStringsDe,
  en: localizationStringsEn,
  fr: localizationStringsFr,
  it: localizationStringsIt,
};

export type IdScanSupportedLanguage = keyof typeof IdScanlocalizationStrings;
